import { mountComponent } from '@/utils';
import React, { useEffect, useState } from 'react';
import { useForm, FormProvider } from 'react-hook-form';
import { BankAccount } from '@/types';
import { useBankAccount } from '../hook/useBankAccount';
import BankAccountForm from './BankAccountForm';

const BankAccountEdit: React.FC = () => {
  const methods = useForm<BankAccount>();
  const { fetchBankAccount, updateBankAccount } = useBankAccount();
  const [initialData, setInitialData] = useState<BankAccount | null>(null);
  const [errors, setErrors] = useState<string[]>([]);
  const [isFetchFailed, setIsFetchFailed] = useState(false);

  useEffect(() => {
    const f = async () => {
      try {
        const bankAccount = await fetchBankAccount();
        setInitialData(bankAccount);
      } catch {
        setIsFetchFailed(true);
      }
    };
    f();
  }, [fetchBankAccount]);

  const onSubmit = async (data: BankAccount): Promise<void> => {
    setErrors([]);

    const result = await updateBankAccount({ bank_account: data });
    if (!result.ok) {
      setErrors(result.errors);
      return;
    }

    alert('銀行口座情報を更新しました!');
  };

  if (isFetchFailed) {
    return (
      <div className='p-3'>
        <div className='alert alert-danger' role='alert'>
          銀行口座情報の取得に失敗しました。時間をおいて再度お試しください。
        </div>
      </div>
    );
  }

  if (!initialData) return <div>Loading...</div>;

  return (
    <FormProvider {...methods}>
      <BankAccountForm
        onSubmit={onSubmit}
        initialData={initialData}
        serverErrors={errors}
        submitLabel='更新する'
      />
    </FormProvider>
  );
};

mountComponent('#bankAccountEdit', () => <BankAccountEdit />);
